<div class="multiproject-manager-container">
  <div class="action-bar">
    <div class="action-buttons-left"></div>
    <div class="action-buttons-right">
      <a class='kpi-button-menu' title="Toggle visibility of enabled multiprojects"
        (click)="showOnlyEnabled = !showOnlyEnabled">
        <span class='glyphicon glyphicon-filter'></span> {{ showOnlyEnabled ? 'Show All' : 'Only Enabled' }}
      </a>
    </div>
  </div>
  <div class="multiproject-content">
    <table mat-table [dataSource]="displayedMultiprojects" class="mat-elevation-z8 multi-table">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let item"> {{item.id}} </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let item">
          @if (editingItemId === item.id) {
            <div>
              <mat-form-field appearance="outline" class="edit-input">
                <input matInput [(ngModel)]="editingItemName" (keyup.enter)="saveUpdate(item.id)"
                  (keyup.escape)="cancelEditing()" cdkFocusInitial>
                </mat-form-field>
              </div>
            } @else {
              {{item.name}}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="enabled">
          <th mat-header-cell *matHeaderCellDef> Visibility </th>
          <td mat-cell *matCellDef="let item">
            <p [innerHTML]="getEnabledDisplay(item.isEnabled)"></p>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let item">
            <div class="action-buttons">
              @if (editingItemId === item.id) {
                <button mat-raised-button class="icon-button save-button" (click)="saveUpdate(item.id)"
                  [disabled]="editingItemName.trim() === originalItemName || !editingItemName.trim()"
                  title="Save Multiproject">
                  <mat-icon class="icon-color-fix">save</mat-icon>
                </button>
                <button mat-raised-button class="icon-button cancel-button" (click)="cancelEditing()"
                  title="Cancel Editing">
                  <mat-icon class="icon-color-fix">cancel</mat-icon>
                </button>
                <button mat-raised-button class="icon-button close-button"
                  (click)="updateMultiprojectStatus(item.id, !item.isEnabled)">
                  @if (item.isEnabled) {
                    <mat-icon class="icon-color-fix"
                    title="Disable Multiproject in Master Data Selection">visibility_off</mat-icon>
                  }
                  @if (!item.isEnabled) {
                    <mat-icon class="icon-color-fix"
                    title="Enable Multiproject in Master Data Selection">visibility</mat-icon>
                  }
                </button>
              } @else {
                <button mat-raised-button class="icon-button edit-button" (click)="startEditing(item)"
                  title="Edit Multiproject">
                  <mat-icon class="icon-color-fix">edit</mat-icon>
                </button>
                <button mat-raised-button class="icon-button close-button" [ngClass]="{'success-button': !item.isEnabled}"
                  (click)="updateMultiprojectStatus(item.id, !item.isEnabled)">
                  @if (item.isEnabled) {
                    <mat-icon class="icon-color-fix"
                    title="Disable Multiproject in Master Data Selection">visibility_off</mat-icon>
                  }
                  @if (!item.isEnabled) {
                    <mat-icon class="icon-color-fix"
                    title="Enable Multiproject in Master Data Selection">visibility</mat-icon>
                  }
                </button>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedMultiColumns;"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedMultiColumns"></tr>
      </table>
      <div class="create-form">
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [(ngModel)]="newItemName" (keyup.enter)="createNewMultiproject()"
            placeholder="New Multiproject Name">
          </mat-form-field>
          <div class="action-buttons">
            <button mat-raised-button class="icon-button add-button" (click)="createNewMultiproject()"
              [disabled]="!newItemName.trim()" title="Add Multiproject">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>